<script setup lang="ts">

import { type ColorPalette, useFabricStore } from '@/store/fabric.ts';
import { useRelationStore, useSelectionStore } from '@repo/stores';
import { computed } from 'vue';

const fabricStore = useFabricStore();
const selectionStore = useSelectionStore();
const relationStore = useRelationStore();

// 获取当前选中面料的materialIndex
const currentMaterialIndex = computed(() => {
  const selectedFabricId = selectionStore.selectedFabricId;
  if (!selectedFabricId) return 0;
  
  const found = relationStore.shapeList.find(item => item.id === selectedFabricId);
  return found?.materialIndex ?? 0;
});

// 根据当前选中的materialIndex获取对应的面料信息
const currentFabricInfo = computed(() => {
  const materialIndex = currentMaterialIndex.value;
  const fabricInfo = fabricStore.getFabricInfoByMaterialIndex(materialIndex);
  
  // 如果是materialIndex=0且没有在map中，使用主fabricInfo
  if (materialIndex === 0 && !fabricInfo) {
    return fabricStore.fabricInfo;
  }
  
  // 其他情况直接返回（可能是undefined）
  return fabricInfo;
});

// 获取当前面料的选中区域索引
const currentSelectedRegionIndex = computed(() => {
  return fabricStore.getSelectedRegionIndex(currentMaterialIndex.value);
});

const regionColor = computed(() => {
  const fabricInfo = currentFabricInfo.value;
  if (!fabricInfo?.mask?.srcImage) {
    return [];
  }
  
  let value = fabricInfo.mask.colors?.map((x:string, index:number)=>{
    let oPalette:ColorPalette = {colorNo : "",color : "", colorName :""};
    oPalette.color = x;
    oPalette.colorNo = String(index + 1);
    return oPalette;
  });

  return value || [];
});

const onClickColor = (index: number) => {
  // 为当前materialIndex设置选中的区域索引
  fabricStore.setSelectedRegionIndex(index, currentMaterialIndex.value);
};

</script>

<template>
  <div v-if="regionColor && regionColor.length > 0" :class="$style.container">
    <div
      v-for="(p, index) of regionColor"
      :key="p.colorNo"
      :class="[$style.colorBlock, { [$style.selected]: currentSelectedRegionIndex === index }]"
      :style="{ backgroundColor: p.color }"
      @click="()=>onClickColor(index)"
    />
  </div>
</template>

<style module>
.container {
  padding: 20px 10px 50px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.colorBlock {
  width: 30px;
  height: 30px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.colorBlock:hover {
  transform: scale(1.1);
}

.colorBlock.selected {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  transform: scale(1.05);
}
</style>
